exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Pjz4{border:none;padding:5px 0;font-weight:400;color:var(--primary--400);color:var(--primary--400);text-align:center;display:block;width:100%}._1as1e{display:block;width:80%;margin:20px auto;position:relative;border-top:1px solid #d6d6d6;border-bottom:1px solid #d6d6d6;padding:10px 0}._1as1e::before{content:\"\\201C\";position:absolute;top:0;left:50%;-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%);background:#fff;width:48px;width:3rem;height:32px;height:2rem;font:6em/1.08em \"PT Sans\",sans-serif;color:#666;text-align:center}._1as1e span{color:#138cb9}", ""]);

// exports
exports.locals = {
	"viewTemplate": "_1Pjz4",
	"template": "_1as1e"
};